export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/web-worker.7f02ac31.worker.js");
}
